import { catColor, catLabel, catIcon } from "@/lib/lore";

export const CategoryBadge = ({ category, className = "" }) => {
  const Icon = catIcon(category);
  const color = catColor(category);
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`inline-flex items-center gap-1 rounded-sm px-1.5 py-0.5 text-[10px] uppercase tracking-[0.14em] font-medium ${className}`}
      style={{ color, background: `${color}1A`, border: `1px solid ${color}40` }}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {catLabel(category)}
    </span>
  );
};

export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      {eyebrow && <div className="lf-label mb-2">{eyebrow}</div>}
      <h1 className="font-display text-4xl sm:text-5xl text-[#F3EBDD] tracking-tight leading-none">{title}</h1>
    </div>
    <div className="flex flex-wrap items-center gap-2">{children}</div>
  </div>
);
